import { init, getLocaleFromNavigator, register } from 'svelte-i18n'
import en from './locales/en.json'
import ru from './locales/ru.json'

// Eager-load default + most common alternative (sync objects → Promise)
register('en', () => Promise.resolve(en))
register('ru', () => Promise.resolve(ru))

export const SUPPORTED_LOCALES = ['en', 'ru'] as const
export const DEFAULT_LOCALE = 'en'

export const LOCALE_LABELS: Record<string, string> = {
  en: 'English',
  ru: 'Русский',
}

export function initI18n(): void {
  // 1. Check user preference (localStorage)
  const saved = typeof localStorage !== 'undefined' ? localStorage.getItem('locale') : null

  // 2. Check browser language
  const browser = getLocaleFromNavigator()
  const browserShort = browser?.split('-')[0] ?? null

  // 3. Resolve: saved > browser > default
  const initial = resolveLocale(saved, browserShort)

  init({
    fallbackLocale: DEFAULT_LOCALE,
    initialLocale: initial,
    loadingDelay: 200,
  })
}

function resolveLocale(saved: string | null, browser: string | null): string {
  const isSupported = (locale: string | null): locale is string =>
    locale !== null && (SUPPORTED_LOCALES as readonly string[]).includes(locale)

  if (isSupported(saved)) return saved
  if (isSupported(browser)) return browser
  return DEFAULT_LOCALE
}

export function setLocale(locale: string): void {
  if ((SUPPORTED_LOCALES as readonly string[]).includes(locale)) {
    localStorage.setItem('locale', locale)
    // svelte-i18n's locale store is reactive — setting it via the store in components
  }
}
